// extracted by mini-css-extract-plugin
export default {"tabs":"RMcid","tab":"_CuBX","small":"LaqYI","medium":"uGw8Q","large":"xxH7n","disabled":"yF_e0","active":"gfH6a"};